"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookies = void 0;
class Cookies {
    constructor(prefix = '') {
        this.prefix = prefix;
    }
    getName(name) {
        /* for short id not used prefix */
        if (['shortId'].indexOf(name) >= 0) {
            return name;
        }
        return this.prefix ? `${this.prefix}_${name}` : name;
    }
    set(name, value, days = 365) {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        const cookieValue = encodeURIComponent(value);
        const cookieName = this.getName(name);
        document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=/`;
    }
    get(name) {
        const cookies = document.cookie.split('; ');
        const cookieName = this.getName(name);
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === cookieName) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }
    delete(name) {
        this.set(name, '', -1);
    }
}
exports.Cookies = Cookies;
